var _jsxFileName = "/opt/atlassian/pipelines/agent/build/src/components/utility/Form/index.tsx";
import React from 'react';
const Form = /*#__PURE__*/React.forwardRef((props, ref) => {
  const {
    children,
    style
  } = props;
  return /*#__PURE__*/React.createElement("div", {
    ref: ref,
    style: {
      display: 'flex',
      flexDirection: 'column',
      height: '100%',
      padding: 16,
      gap: 16,
      ...style
    },
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 10,
      columnNumber: 7
    }
  }, children);
});
Form.displayName = 'Form';
export { Form };